export { default as MultiplierRegisterPage } from './pages/MultiplierRegisterPage';
export { MultiplierViewPage } from './pages/MultiplierViewPage';
export { MultiplierEditPage } from './pages/MultiplierEditPage';

